// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","inner":"Header_inner__A1tAK","link":"Header_link__jrd00","subLink":"Header_subLink__6E22C"};